import snakecaseKeys from 'snakecase-keys';
import { GeneralException } from '@injectivelabs/exceptions';
import { InjectiveWasmxV1Tx } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgExecuteContractCompat extends MsgBase {
    static fromJSON(params) {
        return new MsgExecuteContractCompat(params);
    }
    toProto() {
        const { params } = this;
        const message = InjectiveWasmxV1Tx.MsgExecuteContractCompat.create();
        const msg = this.getMsgObject();
        message.sender = params.sender;
        message.contract = params.contractAddress;
        message.msg = JSON.stringify(msg);
        if (params.funds) {
            const fundsToArray = Array.isArray(params.funds)
                ? params.funds
                : [params.funds];
            const funds = fundsToArray.map((coin) => {
                return `${coin.amount}${coin.denom}`;
            });
            message.funds = funds.join(',');
        }
        else {
            message.funds = '0';
        }
        return InjectiveWasmxV1Tx.MsgExecuteContractCompat.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/injective.wasmx.v1.MsgExecuteContractCompat',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
            msg: JSON.stringify(this.getMsgObject()),
        };
        // @ts-ignore
        delete message.funds_list;
        return {
            type: 'wasmx/MsgExecuteContractCompat',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/injective.wasmx.v1.MsgExecuteContractCompat',
            ...value,
        };
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/injective.wasmx.v1.MsgExecuteContractCompat',
            message: proto,
        };
    }
    toBinary() {
        return InjectiveWasmxV1Tx.MsgExecuteContractCompat.encode(this.toProto()).finish();
    }
    getMsgObject() {
        const { params } = this;
        if ((params.exec || params.msg) && params.execArgs) {
            throw new GeneralException(new Error('Please provide only one exec|msg argument'));
        }
        if (params.execArgs) {
            return params.execArgs.toExecData();
        }
        if (params.exec) {
            return {
                [params.exec.action]: params.exec.msg,
            };
        }
        if (params.msg) {
            return params.msg;
        }
        throw new GeneralException(new Error('Please provide at least one exec argument'));
    }
}
